<template>
    <Layout :isLogin="true">
        <div slot="epassport">
            <iframe
                v-if="showIframe"
                ref="iframe"
                :src="iframeUrl"
                class="login-form"
            ></iframe>
        </div>
    </Layout>
</template>

<script>
import { getLoginUrl } from 'data/sdk';
import { reportLx } from '@lsfe/tools';

const IFRAME_URL = getLoginUrl();

const showIframe = window === window.top;
if (!showIframe) {
    window.top.location.href = '/login.html';
}
export default {
    data() {
        return {
            showIframe,
            IFRAME_URL,
            iframeUrl: IFRAME_URL,
        };
    },
    created() {
        try {
            reportLx('pageView', {
                custom: {},
            }, null, 'c_chaoshi_hi8rr5hz');
        } catch {
            // 埋点pv上报失败
        }
    },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 700px) {
    .login-form {
        width: 100%;
    }
}
</style>
